import { AnalyticsBrowser } from '@segment/analytics-next';
import { TrackingProps } from '../interfaces/tracking/tracking';
import { getCookie } from '../services/cookies/cookies';

const analytics = new AnalyticsBrowser();

export function analyticsLoad(writeKey: string) {
	const analyticsConsentGiven = getCookie('cookieyes-analytics') === 'yes';
	if (analyticsConsentGiven) {
		analytics.load({ writeKey });
	}
}

export function track(props: TrackingProps) {
	if (props.eventName !== undefined && props?.eventName !== '') {
		analytics?.track(props?.eventName?.toString(), {
			url: props.url,
			location: props.location,
		});
	}
}
